import { normalizeUrlPath } from "./policies";

const parseData = (data) => {
  if (typeof data !== "string") return data;
  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
};

export const getOfflineEntityId = (queued) =>
  `offline-${queued.clientRequestId || queued.id}`;

export const getOfflineUserId = (queued) =>
  `offline-user-${queued.clientRequestId || queued.id}`;

const getResource = (queued) =>
  normalizeUrlPath(queued?.url).split("/").filter(Boolean)[0] || "";

export const getCreationReferenceMappings = (queued, responsePayload) => {
  if (queued?.method !== "post") return {};

  const created = responsePayload?.data ?? responsePayload;
  if (!created || typeof created !== "object" || Array.isArray(created)) return {};

  const mappings = {};
  if (created.id !== undefined && created.id !== null) {
    mappings[getOfflineEntityId(queued)] = created.id;
  }

  if (getResource(queued) === "parentfamilies") {
    const userId = created.user?.id ?? created.userId;
    if (userId !== undefined && userId !== null) {
      mappings[getOfflineUserId(queued)] = userId;
    }
  }

  return mappings;
};

const replaceReferences = (value, mappings) => {
  if (typeof value === "string") {
    if (Object.prototype.hasOwnProperty.call(mappings, value)) {
      return mappings[value];
    }
    return Object.entries(mappings).reduce(
      (result, [reference, replacement]) =>
        result.split(reference).join(String(replacement)),
      value
    );
  }
  if (Array.isArray(value)) {
    return value.map((item) => replaceReferences(item, mappings));
  }
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [
        key,
        replaceReferences(item, mappings),
      ])
    );
  }
  return value;
};

export const replaceOfflineReferences = (data, mappings) => {
  const parsed = parseData(data);
  const replaced = replaceReferences(parsed, mappings);
  return typeof data === "string" && typeof replaced !== "string"
    ? JSON.stringify(replaced)
    : replaced;
};

const collectReferences = (value, result) => {
  if (typeof value === "string") {
    const matches = value.match(/offline-(?:user-)?[a-z0-9-]+/gi) || [];
    matches.forEach((reference) => result.add(reference));
  } else if (Array.isArray(value)) {
    value.forEach((item) => collectReferences(item, result));
  } else if (value && typeof value === "object") {
    Object.values(value).forEach((item) => collectReferences(item, result));
  }
};

export const getUnresolvedOfflineReferences = (data) => {
  const references = new Set();
  collectReferences(parseData(data), references);
  return [...references];
};
